module.exports = __webpack_public_path__ + "static/media/logo-snapchat.9c8aede7.svg";